module.exports = __webpack_public_path__ + "b5f4c067d65a55ffaa96358fea3fc09a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-icon.png
// module id = 316
// module chunks = 0